// The Avenue School/the-avenue-school/Client/src/components/Team.js
import React from 'react';
import '../styles/Team.css';
import PageHeader from './PageHeader';
import EnrolmentSection from "./EnrolmentSection";

/**
 * Team page (Figma-matched)
 * - Hero: title + lead
 * - Stacked “cards”: image left, content right, rounded outline
 *
 * NOTE:
 * - Swap the placeholder images with real assets when ready.
 * - If you prefer to feed this from JSON, export the array below.
 */

const teamMembers = [
  {
    name: 'Jarrid',
    role: 'Principal',
    image: '/media/JarridB.jpg',
    imageAlt: 'Portrait of Jarrid',
  },
    {
    name: 'Marissa',
    role: 'Teacher',
    image: '/media/Marissa.png',
    imageAlt: 'Portrait of Marissa',
  },
  {
    name: 'Ish',
    role: 'STUDENT COUNSELLOR',
    image: '/media/Ish.png',
    imageAlt: 'Portrait of Ish',
  },
  {
    name: 'Kim',
    role: 'YOUTH WORKER',
    image: '/media/Kim.png',
    imageAlt: 'Portrait of Kim',
  },
    {
    name: 'Kerrie',
    role: 'EDUCATION SUPPORT WORKER',
    image: '/media/Kerrie.png',
    imageAlt: 'Portrait of Kerrie',
  },
      {
    name: 'Georgia',
    role: 'EDUCATION SUPPORT WORKER',
    image: '/media/Georgia.png',
    imageAlt: 'Portrait of Georgia',
  },
      {
    name: 'Innes',
    role: 'TEACHER',
    image: '/media/Innes.png',
    imageAlt: 'Portrait of Innes',
  },
      {
    name: 'Gayan',
    role: 'BUSINESS MANAGER',
    image: '/media/Gayan.png',
    imageAlt: 'Portrait of Gayan',
  },
];

const Team = () => {
  return (
    <main className="teamPage" aria-labelledby="team-hero-title">
              {/* Page Header */}
      <PageHeader eyebrow="Team" title="Team" image="/media/gallery-1.jpg"
        height="200px"/>
      <section className="teamHero">
        <h1 id="team-hero-title" className="teamHero__title">Meet our team members</h1>
        <p className="teamHero__lead">
          Get to know the passionate individuals that make our school so special.
        </p>
      </section>

      <section className="teamList">
        {teamMembers.map((m, idx) => (
          <article key={idx} className="teamCard">
            <div className="teamCard__media">
              <img src={m.image} alt={m.imageAlt || `${m.name} headshot`} />
            </div>
            <div className="teamCard__body">
              <h2 className="teamCard__name">{m.name}</h2>
              <p className="teamCard__role">{m.role}</p>
            </div>
          </article>
        ))}
      </section>
            {/* CTA Section */}
      <EnrolmentSection />
    </main>
  );
};

export default Team;
